export default __webpack_public_path__ + "static/media/icons8-discord.4ccbeee9.svg";